import actions from './actions';

const { LISTING_PARTNER_LIST_BEGIN, LISTING_PARTNER_LIST_SUCCESS, LISTING_PARTNER_LIST_ERR } = actions;

const initState = {
  list: null,
  loading: false,
  error: null,
};
/**
 *
 * @todo impure state mutation/explaination
 */
const ListingPartnerReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LISTING_PARTNER_LIST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LISTING_PARTNER_LIST_SUCCESS:
      return {
        ...state,
        list: data,
        loading: false,
      };
    case LISTING_PARTNER_LIST_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default ListingPartnerReducer;
